import { Hero } from '../components/sections/Hero';
import { About } from '../components/sections/About';
import { Portfolio } from '../components/sections/Portfolio';
import { Services } from '../components/sections/Services';
import { Testimonials } from '../components/sections/Testimonials';
import { Blog } from '../components/sections/Blog';
import { Contact } from '../components/sections/Contact';
import { SEO } from '../components/SEO';

export const Home = () => {
  return (
    <main data-testid="home-page">
      <SEO 
        title={null}
        description="Fotógrafo profesional en Burgos especializado en bodas, eventos, retratos y fotografía comercial. Más de 10 años capturando momentos únicos con pasión y creatividad."
        url="https://jonquintano.com"
      />
      <Hero />
      <About />
      <Portfolio />
      <Services />
      <Testimonials />
      <Blog />
      <Contact />
    </main>
  );
};

export default Home;
